<template>
  <div class="naplata-wrapper">
    <div class="naplata-inner-wrapper">
      <div class="naplata-top">
        <div class="naplata-top-left">
          <div class="naplata-icon"><svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37"><g><g><path fill="#3326ae" d="M35.757 16.427l-7.798 7.81v9.569a3.23 3.23 0 0 1-3.226 3.228H3.226A3.23 3.23 0 0 1 0 33.806V3.53A3.23 3.23 0 0 1 3.226.302h18.466c.861 0 1.672.336 2.281.946l3.041 3.044c.61.61.945 1.42.945 2.282v8.528l3.236-3.24a3.228 3.228 0 0 1 4.562 4.565zM21.507 6.76h4.302c0-.23.026-.604-.315-.945L22.452 2.77c-.35-.35-.742-.315-.945-.315zm4.302 27.047V26.39l-.13.131a1.075 1.075 0 0 1-.421.26l-4.562 1.522a1.074 1.074 0 0 1-1.36-1.361l1.52-4.566c.053-.158.142-.303.26-.42l1.52-1.522 3.173-3.177V8.91h-5.377a1.076 1.076 0 0 1-1.075-1.076v-5.38H3.226c-.593 0-1.075.482-1.075 1.076v30.275c0 .593.482 1.076 1.075 1.076h21.507c.593 0 1.076-.483 1.076-1.076zm-2.993-10.508l-.76 2.282 2.28-.76.582-.582-1.521-1.522zm8.792-5.76l-1.521-1.521-5.17 5.177 1.521 1.522zm2.629-4.154a1.076 1.076 0 0 0-1.521 0l-1.109 1.11 1.52 1.522 1.11-1.11a1.076 1.076 0 0 0 0-1.522zm-12.73-1.244c0 .594-.481 1.076-1.075 1.076H5.377a1.076 1.076 0 0 1 0-2.152h15.055c.594 0 1.075.481 1.075 1.076zm-4.301 4.304c0 .594-.482 1.076-1.076 1.076H5.377a1.076 1.076 0 0 1 0-2.152H16.13c.594 0 1.076.482 1.076 1.076zm0 4.305c0 .594-.482 1.076-1.076 1.076H5.377a1.076 1.076 0 0 1 0-2.152H16.13c.594 0 1.076.481 1.076 1.076zm0 4.304c0 .594-.482 1.076-1.076 1.076H5.377a1.076 1.076 0 0 1 0-2.152H16.13c.594 0 1.076.482 1.076 1.076zm4.301 6.6c0 .595-.481 1.076-1.075 1.076H13.98a1.076 1.076 0 0 1 0-2.152h6.452c.594 0 1.075.482 1.075 1.076z"/></g></g></svg></div>
          <div class="naplata-title">Naplata po ugovoru</div>
        </div>
        <div class="naplata-close"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21"><g><g><path fill="#7b7b8a" d="M13.125 10.764l7.66-7.655c.21-.21.327-.491.327-.791 0-.3-.116-.582-.327-.792l-.671-.67a1.111 1.111 0 0 0-.793-.327c-.3 0-.581.115-.792.326l-7.66 7.655L3.209.855A1.11 1.11 0 0 0 2.416.53c-.3 0-.58.115-.791.326l-.672.671a1.12 1.12 0 0 0 0 1.583l7.66 7.655-7.66 7.655c-.211.21-.327.492-.327.792 0 .3.116.58.327.791l.671.671c.211.211.493.327.792.327.3 0 .582-.116.793-.327l7.66-7.654 7.66 7.654c.21.211.492.327.792.327.3 0 .581-.116.792-.327l.672-.67c.21-.211.327-.493.327-.792 0-.3-.117-.581-.327-.792z"/></g></g></svg></div>
      </div>
      <div class="naplata-secton1">
          <div class="ns1-item1">
            <div class="ns-label">Vrsta ugovora</div>
            <div class="naplata-dropdown">
              <select id="search-group">
                <option value="all">Mješovita naplata</option>
                <option value="uloga">Još neka naplata</option>
                <option value="uloga">I treća naplata</option>
              </select>
              <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg"/>
            </div>  
          </div>
          <div class="ns1-item2">
              <div class="ns-label">Naslov</div>
              <div class="ns-input ns-naslov">Ugovor: Legroux/Pitre- parnični postupak</div>
          </div>
          <div class="ns1-item3">
              <div class="ns-label">Ugovor</div>
              <div class="ns-contract"> 
                <div class="ns-contract-icon"><img class="doc-icon" src="@/assets/img/pdf_icon.svg" /></div>
                Legroux/Pitre_ugovor.pdf
              </div>
          </div>
      </div>
      <div class="sveukupno">
        <div class="sveukupno-label">sveukupno</div>
        <div class="sveukupno-iznos">33.250,00kn</div>
      </div>
      <div class="naplata-secton2">
          <div class="ns-label nsl-top">Fiksne stavke</div>
          <div class="ns-board-wrapper">
            <div class="label-row">
              <div class="label-column ns-label nsl-top lc1"></div>
              <div class="label-column ns-label nsl-top lc2">Datum</div>
              <div class="label-column ns-label nsl-top lc3">Opis stavke</div>
              <div class="label-column ns-label nsl-top lc-end">Iznos</div>
            </div>
            <div class="naplata-stavka-row">
              <div class="naplata-stavka-column nsc-redni">1</div>
              <div class="naplata-stavka-column ns-input nsc-input-pt1">22.02.2020. <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21"><g><g><path fill="#3326ae" d="M20.624 4.69v13.64a2.33 2.33 0 0 1-2.33 2.324H3.067a2.33 2.33 0 0 1-2.33-2.325V4.69a2.33 2.33 0 0 1 2.33-2.325H4V.814h1.553v1.55h10.255V.814h1.554v1.55h.932a2.33 2.33 0 0 1 2.33 2.325zM19.071 8.1H2.29v10.23c0 .427.348.774.776.774h15.227a.777.777 0 0 0 .777-.775zm0-3.41a.777.777 0 0 0-.777-.775h-.932v1.55h-1.554v-1.55H5.553v1.55H4v-1.55h-.933a.777.777 0 0 0-.777.774v1.86h16.78zM3.689 9.726h1.554v1.55H3.689zm3.107 0H8.35v1.55H6.796zm3.108 0h1.553v1.55H9.904zm3.107 0h1.554v1.55H13.01zm3.108 0h1.553v1.55H16.12zm-12.43 3.1h1.554v1.55H3.689zm3.107 0H8.35v1.55H6.796zm3.108 0h1.553v1.55H9.904zm3.107 0h1.554v1.55H13.01zm-9.322 3.1h1.554v1.55H3.689zm3.107 0H8.35v1.55H6.796zm3.108 0h1.553v1.55H9.904zm3.107 0h1.554v1.55H13.01zm3.108-3.1h1.553v1.55H16.12z"/></g></g></svg></div>
              <div class="naplata-stavka-column ns-input nsc-input-pt2"><input type="text" placeholder="Sastav privatne tužbe i kaznene prijave temeljem kojeg se pokreće..."></div>
              <div class="naplata-stavka-column ns-input nsc-input-end"><input type="numbers" placeholder="500,00kn"></div>
            </div>
            <div class="naplata-stavka-row">
              <div class="naplata-stavka-column nsc-redni">2</div>
              <div class="naplata-stavka-column ns-input nsc-input-pt1">22.02.2020. <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21"><g><g><path fill="#3326ae" d="M20.624 4.69v13.64a2.33 2.33 0 0 1-2.33 2.324H3.067a2.33 2.33 0 0 1-2.33-2.325V4.69a2.33 2.33 0 0 1 2.33-2.325H4V.814h1.553v1.55h10.255V.814h1.554v1.55h.932a2.33 2.33 0 0 1 2.33 2.325zM19.071 8.1H2.29v10.23c0 .427.348.774.776.774h15.227a.777.777 0 0 0 .777-.775zm0-3.41a.777.777 0 0 0-.777-.775h-.932v1.55h-1.554v-1.55H5.553v1.55H4v-1.55h-.933a.777.777 0 0 0-.777.774v1.86h16.78zM3.689 9.726h1.554v1.55H3.689zm3.107 0H8.35v1.55H6.796zm3.108 0h1.553v1.55H9.904zm3.107 0h1.554v1.55H13.01zm3.108 0h1.553v1.55H16.12zm-12.43 3.1h1.554v1.55H3.689zm3.107 0H8.35v1.55H6.796zm3.108 0h1.553v1.55H9.904zm3.107 0h1.554v1.55H13.01zm-9.322 3.1h1.554v1.55H3.689zm3.107 0H8.35v1.55H6.796zm3.108 0h1.553v1.55H9.904zm3.107 0h1.554v1.55H13.01zm3.108-3.1h1.553v1.55H16.12z"/></g></g></svg></div>
              <div class="naplata-stavka-column ns-input nsc-input-pt2"><input type="text" placeholder="Sastav kaznene prijave za kaznena djela"></div>
              <div class="naplata-stavka-column ns-input nsc-input-end"><input type="numbers" placeholder="1.000,00kn"></div>
            </div>
            <div class="naplata-stavka-row">
              <div class="naplata-stavka-column nsc-redni">3</div>
              <div class="naplata-stavka-column ns-input nsc-input-pt1">22.02.2020. <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21"><g><g><path fill="#3326ae" d="M20.624 4.69v13.64a2.33 2.33 0 0 1-2.33 2.324H3.067a2.33 2.33 0 0 1-2.33-2.325V4.69a2.33 2.33 0 0 1 2.33-2.325H4V.814h1.553v1.55h10.255V.814h1.554v1.55h.932a2.33 2.33 0 0 1 2.33 2.325zM19.071 8.1H2.29v10.23c0 .427.348.774.776.774h15.227a.777.777 0 0 0 .777-.775zm0-3.41a.777.777 0 0 0-.777-.775h-.932v1.55h-1.554v-1.55H5.553v1.55H4v-1.55h-.933a.777.777 0 0 0-.777.774v1.86h16.78zM3.689 9.726h1.554v1.55H3.689zm3.107 0H8.35v1.55H6.796zm3.108 0h1.553v1.55H9.904zm3.107 0h1.554v1.55H13.01zm3.108 0h1.553v1.55H16.12zm-12.43 3.1h1.554v1.55H3.689zm3.107 0H8.35v1.55H6.796zm3.108 0h1.553v1.55H9.904zm3.107 0h1.554v1.55H13.01zm-9.322 3.1h1.554v1.55H3.689zm3.107 0H8.35v1.55H6.796zm3.108 0h1.553v1.55H9.904zm3.107 0h1.554v1.55H13.01zm3.108-3.1h1.553v1.55H16.12z"/></g></g></svg></div>
              <div class="naplata-stavka-column ns-input nsc-input-pt2"><input type="text" placeholder="Sastav podneska kojim se postavlja imovinsko pravni zahtjev oštećenika"></div>
              <div class="naplata-stavka-column ns-input nsc-input-end"><input type="numbers" placeholder="500,00kn"></div>
            </div>
            <div class="naplata-stavka-row">
              <div class="naplata-stavka-dodaj">
                <div class="naplata-dodaj-plus"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><g><g><path fill="#7b7b8a" d="M10.88 4.72a.734.734 0 0 0-.537-.219H7.06V1.253a.72.72 0 0 0-.221-.531.735.735 0 0 0-.537-.218H4.787c-.21 0-.39.072-.537.218a.72.72 0 0 0-.22.531v3.248H.745c-.21 0-.39.073-.537.218a.719.719 0 0 0-.22.531v1.5c0 .208.073.385.22.53a.735.735 0 0 0 .537.219h3.283v3.248a.72.72 0 0 0 .221.53.735.735 0 0 0 .537.22h1.515c.21 0 .39-.074.537-.22a.72.72 0 0 0 .221-.53V7.499h3.283c.21 0 .39-.073.537-.218a.72.72 0 0 0 .221-.532V5.25a.719.719 0 0 0-.221-.53z"/></g></g></svg></div>
                <div class="naplata-dodaj-tekst">dodaj novu stavku</div>
              </div>
            </div>
            <div class="naplata-ukupno">
              <div class="naplata-ukupno-label">ukupno</div>
              <div class="naplata-ukupno-iznos">5.530,00kn</div>
            </div>
            <div class="naplata-pdv">
              <div class="naplata-ukupno-label">pdv 25%</div>
              <div class="naplata-ukupno-iznos">1.382,50kn</div>
            </div>
          </div>
      </div>
      <div class="naplata-secton3">
        <div class="ns-label nsl-top">Po uspjehu</div>
          <div class="ns-board-wrapper">
            <div class="label-row">
              <div class="label-column ns-label lc1"></div>
              <div class="label-column ns-labell nsl-top lc-end">Iznos</div>
            </div>
            <div class="naplata-stavka-row">
              <div class="naplata-stavka-column ns-label">Ukupna vrijednost</div>
              <div class="naplata-stavka-column ns-input ukupna-vrijednost-input"><input type="numbers" placeholder="100.000,00kn"></div>
            </div>
            <div class="naplata-stavka-row">
              <div class="naplata-stavka-column ns-label">Postotak</div>
              <div class="naplata-stavka-column ns-input postotak-input"><input type="numbers" placeholder="25%"></div>
            </div>
            <div class="naplata-ukupno">
              <div class="naplata-ukupno-label">iznos</div>
              <div class="naplata-ukupno-iznos">25.000,00kn</div>
            </div>
            <div class="naplata-pdv">
              <div class="naplata-ukupno-label">pdv 25%</div>
              <div class="naplata-ukupno-iznos">31.250,90kn</div>
            </div>
          </div>
      </div>
      <div class="sveukupno bottom-sveukupno">
        <div class="sveukupno-label">sveukupno</div>
        <div class="sveukupno-iznos">33.250,00kn</div>
      </div>
      <div class="kreiraj-button">Kreiraj troškovnik</div>
    </div>
  </div>
</template>

<script>
import share from "@/apiCallers/sharepoint";
import auth from "@/services/auth";
import moment from "moment"
import $ from "jquery";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";


export default {
  data() {
    return {
       predmet_info:null,
      fiz_stranke:null,
      prav_protustranke:null,
      accessToken: "",
      files: [],
      loading: false,
      selectedFolder: null,
      selectedFile: "",
      progress: 0,
      filesInSpis: [],
      nazivDokumenta: "",
      folders: [],
      //Parrent refId ima funkciju da je uvijek trenutni direktorij na vrhu (njegov id)
      newDirectoryName: "",
      parrentRefId: "",
      postaRootId: "",
      radniRootId: "",
      activityFile : null,
      ulaznaPosta: [],
      izlaznaPosta:[],
      radniDokumenti: [],
      nazivSpisFoldera: "",
      currDirectory: [],
      breadCrumbs: [],
      tmpBread: {
        id: "",
        nazivFoldera: "",
        idx: 0,
      },
    };
  },
  watch: {
    accessToken: function () {
      if (this.accessToken) {
        this.getRootDocuments();
      }
    },
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
    predmet_hand.getSingle(this.$route.params.uid).then((response) => {
          console.log(response)

          this.predmet_info = response.data.all_info_predmet.predmet_info[0]
          this.fiz_stranke = response.data.all_info_predmet.fiz_stranke
          this.prav_protustranke = response.data.all_info_predmet.prav_protustranke



        });
  },
  methods: {
    goToPredmet(nastavak)
    {
      this.$router.push(nastavak)

    },
    switchDate(inData) {
      return moment(inData.toString()).format("lll");
    },
    switchDateRow(inData) {
      return moment(inData.toString()).format("L");
    },
    goStepBack() {
      this.folders = [];
      this.filesInSpis = [];
      this.parrentRefId = this.parrentRefId.pop();
      this.goDown(this.parrentRefId[parrentRefId.length - 1]);
    },

    openFile(linkToFile) {
      window.open(linkToFile);
    },
    deleteFile(fileId) {
      var path = "/drive/items/" + fileId;
      share
        .deleteFile(this.accessToken, this.$route.params.uid, path)
        .then(() => {
          this.goDown(this.selectedFolder);
        });
    },
    // createNewFolder() {
    //   share.newFolder(
    //     this.accessToken,
    //     this.$route.params.uid,
    //     this.nazivFoldera
    //   );
    // },
     setFileForActivity(fileRef) {
      this.activityFile = fileRef;
      console.log(this.activityFile);
    },
    toPDF(file) {
      var path = "/drive/items/" + file.id;
      console.log(path);
      console.log(this.breadCrumbs[this.breadCrumbs.length - 1].id);

      share
        .convertToPDF(
          this.accessToken,
          this.$route.params.uid,
          this.breadCrumbs[this.breadCrumbs.length - 1].id,
          path
        )
        .then((response) => {
          console.log(response.data["@microsoft.graph.downloadUrl"]);
        });
    },
    onFileChange(e) {
      const selectedFile = e.target.files[0];
      this.selectedFile = selectedFile;
      console.log(this.selectedFile);
    },
    // createNewDocument() {
    //   this.selectedFile = new Document({
    //     name: "Somefile.docx",
    //   });

    //   var formData = new FormData();
    //   formData.append("file", this.selectedFile);
    //   formData.append("token", this.accessToken);
    //   formData.append("groupId", this.$route.params.uid);
    //   formData.append("sid", this.selectedFolder);
    //   formData.append("name", this.nazivDokumenta);
    //   console.log(this.nazivDokumenta);
    //   // appending file

    //   share.addDocumentInSpis(formData).then(() => {
    //     this.goDown(this.selectedFolder);
    //     this.nazivDokumenta = "";
    //   });
    // },

    previewFiles() {
      var input = document.getElementById("myFiles");
      var file = input.files[0];
      console.log(file);
      share.addDocumentInSpis(
        this.accessToken,
        this.$route.params.uid,
        this.selectedFolder,
        file
      );
    },
    async addNewUploadFile() {
      const formData = new FormData();
      console.log(this.selectedFile);
      formData.append("file", this.selectedFile);
      formData.append("token", this.accessToken);
      formData.append("groupId", this.$route.params.uid);
      formData.append("sid", this.breadCrumbs[this.breadCrumbs.length - 1].id);
      formData.append("name", this.selectedFile.name);
      // appending file

      share.addDocumentInSpis(formData);
      setTimeout(() => {
        this.currDirectory = this.getAllDocsById(
          this.breadCrumbs[this.breadCrumbs.length - 1].id
        );
      }, 200);
    },
    createNewFolder() {
      this.createFoldToParrent(
        this.breadCrumbs[this.breadCrumbs.length - 1].id,
        this.newDirectoryName
      );
    },
    createFoldToParrent(parrentId, docname) {
      share.createFolderDocs(
        this.accessToken,
        this.$route.params.uid,
        parrentId,
        docname
      );
      // .then(() => {
      //   this.goDown(this.selectedFolder);
      //   this.nazivDokumenta = "";
      // });
    },
    breadcrumbsViewPushback(indexCut) {
      if (this.breadCrumbs.length > 1) {
        this.breadCrumbs = this.breadCrumbs.slice(0, indexCut + 1);
        this.currDirectory = this.getAllDocsById(
          this.breadCrumbs[this.breadCrumbs.length - 1].id
        );
      }
    },
    setNewFileView(foldRef) {
      //primi id foldera čiju ćemo djecu pregledati
      //Nakon toga napravi poziv i osvježi koje su datoteke unutra
      var duljina = this.breadCrumbs.length;
      this.breadCrumbs.push({
        id: foldRef.id,
        nazivFoldera: foldRef.name,
        idx: duljina,
      });
      this.currDirectory = this.getAllDocsById(foldRef.id);
    },
    setInitFileView(foldRef) {
      //primi id foldera čiju ćemo djecu pregledati
      //Nakon toga napravi poziv i osvježi koje su datoteke unutra
      this.breadCrumbs = [];
      var duljina = this.breadCrumbs.length;
      this.breadCrumbs.push({
        id: foldRef.id,
        nazivFoldera: foldRef.name,
        idx: duljina,
      });
      this.currDirectory = this.getAllDocsById(foldRef.id);
    },
    createNewSpis() {
      this.createFoldToParrent(this.postaRootId, this.nazivSpisFoldera);
    },
    getAllDocsById(sid) {
      var ret_fold = [];
      var ret_files = [];
      share
        .getDocumentsInSpis(this.accessToken, this.$route.params.uid, sid)
        .then((response) => {
          response.data.value.forEach((dat) => {
            if (dat.folder != undefined) {
              ret_fold.push(dat);
            }else{
              ret_files.push(dat);
            }
          });
        });
        console.log(ret_fold);
        console.log(ret_files);
      return ret_fold;
    },
    getfoldersById(sid) {
      var ret_fold = [];
      share
        .getDocumentsInSpis(this.accessToken, this.$route.params.uid, sid)
        .then((response) => {
          response.data.value.forEach((dat) => {
              ret_fold.push(dat);
          });
        });
      return ret_fold;
    },
    getRootDocuments() {
      console.log(this.$route.params.uid);
      console.log(this.accessToken);
      share
        .getRootDocs(this.accessToken, this.$route.params.uid)
        .then((response) => {
          response.data.files.value.forEach((doc) => {
            if (doc.name == "Izlazna pošta") {
              this.postaRootId = doc.id;
              this.izlaznaPosta = this.getfoldersById(this.postaRootId);
              console.log(this.izlaznaPosta);             
            }else if(doc.name == "Ulazna pošta") {
              this.postaRootId = doc.id;
              this.ulaznaPosta = this.getfoldersById(this.postaRootId);
              console.log(this.ulaznaPosta);             
            }
          });
        });
    },
  },
  mounted() {},
};
</script>

<style>
</style>